import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteSalaireGroup, getSalaireGroupById } from './salaire.reducer';
import { SalaireParams } from 'app/shared/model/salaire.model';

export const SalaireDeleteModal = ({ match, history }: RouteComponentProps<SalaireParams>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const salaireGroupId = match.params.salaireGroupId;
  const ecoleId = match.params.ecoleid;
  const anneeScolaireId = match.params.anneeScolaireId;

  const dispatch = useAppDispatch();
  const loading = useAppSelector(state => state.salaire.loading);
  const salaireGroup = useAppSelector(state => state.salaire.salaireGroup);

  useEffect(() => {
    dispatch(getSalaireGroupById(salaireGroupId));
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = event => {
    event.stopPropagation();
    history.goBack();
  };

  const confirmDelete = event => {
    event.stopPropagation();
    dispatch(deleteSalaireGroup({ salaireGroupId, ecoleId, anneeScolaireId }));
    handleClose(event);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" loading={loading} style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer le salaire {`${salaireGroup.mois} ${salaireGroup.annee}`} ?
    </Modal>
  );
};

export default SalaireDeleteModal;
